var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles, Snackbar as MUISnackbar, useMediaQuery, } from '@material-ui/core';
import theme from '@core/theme';
var useStyles = makeStyles(function () {
    var _a;
    return ({
        root: (_a = {},
            _a[theme.breakpoints.up('md')] = {
                maxWidth: 600,
            },
            _a),
        error: {
            backgroundColor: theme.palette.error.dark,
            color: theme.palette.common.white,
        },
        success: {
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.common.white,
        },
        warning: {
            backgroundColor: theme.palette.warning.main,
            color: theme.palette.common.white,
        },
        info: {
            backgroundColor: theme.palette.info.dark,
            color: theme.palette.common.white,
        },
    });
});
var Snackbar = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'success' : _b, _c = _a.time, time = _c === void 0 ? 5000 : _c, message = _a.message, props = __rest(_a, ["variant", "time", "message"]);
    var classes = useStyles();
    var isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    return (React.createElement(MUISnackbar, __assign({ className: classes.root, ContentProps: { className: classes[variant] }, autoHideDuration: time, transitionDuration: 400, anchorOrigin: {
            vertical: 'top',
            horizontal: isDesktop ? 'right' : 'center',
        }, message: message }, props)));
};
export default Snackbar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU25hY2tiYXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9TbmFja2Jhci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLE9BQU8sS0FBYSxNQUFNLE9BQU8sQ0FBQztBQUNsQyxPQUFPLEVBQ0wsVUFBVSxFQUNWLFFBQVEsSUFBSSxXQUFXLEVBRXZCLGFBQWEsR0FDZCxNQUFNLG1CQUFtQixDQUFDO0FBQzNCLE9BQU8sS0FBSyxNQUFNLGFBQWEsQ0FBQztBQUVoQyxJQUFNLFNBQVMsR0FBRyxVQUFVLENBQUM7O0lBQU0sT0FBQSxDQUFDO1FBQ2xDLElBQUk7WUFDRixHQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxJQUFHO2dCQUM1QixRQUFRLEVBQUUsR0FBRzthQUNkO2VBQ0Y7UUFDRCxLQUFLLEVBQUU7WUFDTCxlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsSUFBSTtZQUN6QyxLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsS0FBSztTQUNsQztRQUNELE9BQU8sRUFBRTtZQUNQLGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxJQUFJO1lBQzNDLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxLQUFLO1NBQ2xDO1FBQ0QsT0FBTyxFQUFFO1lBQ1AsZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLElBQUk7WUFDM0MsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEtBQUs7U0FDbEM7UUFDRCxJQUFJLEVBQUU7WUFDSixlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsSUFBSTtZQUN4QyxLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsS0FBSztTQUNsQztLQUNGLENBQUM7QUF0QmlDLENBc0JqQyxDQUFDLENBQUM7QUFPSixJQUFNLFFBQVEsR0FBc0IsVUFBQyxFQUtwQztJQUpDLElBQUEsZUFBbUIsRUFBbkIsd0NBQW1CLEVBQ25CLFlBQVcsRUFBWCxnQ0FBVyxFQUNYLG9CQUFPLEVBQ1Asa0RBQVE7SUFFUixJQUFNLE9BQU8sR0FBRyxTQUFTLEVBQUUsQ0FBQztJQUM1QixJQUFNLFNBQVMsR0FBRyxhQUFhLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxFQUFFLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztJQUU1RCxPQUFPLENBQ0wsb0JBQUMsV0FBVyxhQUNWLFNBQVMsRUFBRSxPQUFPLENBQUMsSUFBSSxFQUN2QixZQUFZLEVBQUUsRUFBRSxTQUFTLEVBQUUsT0FBTyxDQUFDLE9BQU8sQ0FBQyxFQUFFLEVBQzdDLGdCQUFnQixFQUFFLElBQUksRUFDdEIsa0JBQWtCLEVBQUUsR0FBRyxFQUN2QixZQUFZLEVBQUU7WUFDWixRQUFRLEVBQUUsS0FBSztZQUNmLFVBQVUsRUFBRSxTQUFTLENBQUMsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsUUFBUTtTQUMzQyxFQUNELE9BQU8sRUFBRSxPQUFPLElBQ1osS0FBSyxFQUNULENBQ0gsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGVBQWUsUUFBUSxDQUFDIn0=